module.exports = __webpack_public_path__ + "img/placeholder.ce927d4c.png";